import isEmpty from "is-empty";
import React from "react";
import { setAuthDetails, setUserData, setAllowedGames } from "../../redux/features/accountSlice";
import { useEffect } from "react";
import { userAuth } from "../../service/AuthService";
import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import { IS_PROD } from "../../utils/constants";
import { IS_MOCK, MOCK_USER_DATA } from "../../utils/mockData";
import { emitCasinoReady } from "../../utils/postMessageBridge";

const Launch = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchData = useCallback(
    async (token, operatorId, homeUrl) => {
      // You can await here
      const res = await userAuth(operatorId);

      if (res.status === 200) {
        const authDetails = { ...res.data.data, homeUrl, token };
        localStorage.setItem("authDetails", JSON.stringify(authDetails));
        dispatch(
          setAuthDetails({
            ...res.data.data,
            homeUrl,
            token,
          })
        );
        dispatch(
          setUserData({
            ...res.data.data,
            homeUrl,
            token,
          })
        );
        localStorage.setItem("authenticated", "yes");
        if (res.data.data?.allowedGames) {
          dispatch(setAllowedGames(res.data.data.allowedGames));
          localStorage.setItem("allowedGames", JSON.stringify(res.data.data.allowedGames));
        }
        emitCasinoReady(res.data.data);
        navigate(`/live-casino?operatorId=${operatorId}`);
      } else {
        navigate("/un-auth");
      }
    },
    [dispatch, navigate]
  );

  useEffect(() => {
    if (IS_MOCK) {
      localStorage.setItem("token", MOCK_USER_DATA.token);
      localStorage.setItem("authenticated", "yes");
      localStorage.setItem("operatorId", JSON.stringify(MOCK_USER_DATA.operatorId));
      localStorage.setItem("authDetails", JSON.stringify(MOCK_USER_DATA));
      dispatch(setAuthDetails(MOCK_USER_DATA));
      dispatch(setUserData(MOCK_USER_DATA));
      navigate(`/live-casino?operatorId=${MOCK_USER_DATA.operatorId}`);
      return;
    }
    const token = searchParams.get("token");
    const _authDetails = JSON.parse(localStorage.getItem("authDetails"));

    const operatorId =
      searchParams.get("operatorId") || _authDetails?.operatorId;
    const homeUrl = searchParams.get("homeUrl");

    const authenticated = localStorage.getItem("authenticated");

    if (isEmpty(authenticated) || authenticated !== "yes") {
      if (token) {
        setTimeout(() => {
          fetchData(token, operatorId, homeUrl);
        }, 500);

        localStorage.setItem("token", token);
      }
    } else {
      navigate(`/live-casino?operatorId=${operatorId}`);
    }
  }, [dispatch, fetchData, location.pathname, navigate, searchParams]);
  return (
    <>
      <Loading />
    </>
  );
};

export default Launch;
